import React from 'react'
import {colors} from "../../utils/styles"
import {merge} from "../../utils/util"

const modalStack = []

export class N2C3Modal extends React.Component {
  constructor(props) {
    super(props)
    modalStack.push(props.modalClass)
    this.state = {
      modalStyle: {
        backgroundColor: colors.white,
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.2)',
        position: 'fixed',
        top: 80,
        fontSize: 14,
        opacity: '1.0'
      },
      zIndex: 400 + (modalStack.length * 10)
    }
    if (props.width && !props.noMask) {
      this.state.modalStyle.width = props.width
      this.state.modalStyle.left = 'calc(50vw - ' + Math.floor(props.width / 2) + 'px)'
    }

    if (props.extraStyle) {
      this.state.modalStyle = merge(this.state.modalStyle, props.extraStyle)
    }
  }

  componentWillUnmount() {
    const idx = modalStack.indexOf(this.props.modalClass)
    modalStack.splice(idx, 1)
  }

  render() {
    //no mask enables user interaction behind modals
    const {noMask, chatStyle} = this.props
    const style = merge({zIndex: this.state.zIndex, position: 'fixed'}, chatStyle)

    return (
        <div className={noMask ? "" : "modal-effect"} style={style}>
          <div style={this.state.modalStyle} className={this.props.modalClass}>
            {this.props.children}
          </div>
        </div>
    )
  }
}